// INIT STATE
import { getEmpresas } from '../../../../services/localstorage/localstorage.service'

export const INIT_STATE = {
  originalEntregas: [],
  entregas: [],
  isLoading: false,
  listaStatus: [
    { value: 1, label: 'Aguardando Conferência' },
    { value: 16, label: 'Picking Concluído' },
    { value: 2, label: 'Conferido' },
    { value: 4, label: 'Aguardando Carregamento' },
  ],
  listaEmpresas: [],
  selectedStatus: [],
  selectedEmpresas: [],
  selectedModeloIntegracao: '',
  selecionarTodos: false,
  selectedEntrega: undefined,
  modalIsVisible: false,
  considerarEntregasEmSeparacao: true,
}

//ACTION
const GET_ENTREGAS = 'GET_ENTREGAS'

export function onGetEntregas(entregas) {
  return { action: GET_ENTREGAS, payload: entregas }
}

const SELECTED_STATUS_CHANGE = 'SELECTED_STATUS_CHANGE'

export function onSeletedStatusChange(status) {
  return { action: SELECTED_STATUS_CHANGE, payload: status }
}

const SELECTED_EMPRESAS_CHANGE = 'SELECTED_EMPRESAS_CHANGE'

export function onSeletedEmpresasChange(empresa) {
  return { action: SELECTED_EMPRESAS_CHANGE, payload: empresa }
}

const MODELO_INTEGRACAO_CHANGE = 'MODELO_INTEGRACAO_CHANGE'

export function onModeloIntegracaoChange(modelo) {
  return { action: MODELO_INTEGRACAO_CHANGE, payload: modelo }
}

const SELECIONAR_ENTREGA_CLICK = 'SELECIONAR_ENTREGA_CLICK'

export function onSelecionarEntregaClick(entrega) {
  return { action: SELECIONAR_ENTREGA_CLICK, payload: entrega }
}

const SELECIONAR_TODOS_CLICK = 'SELECIONAR_TODOS_CLICK'

export function onSelecionarTodosClick() {
  return { action: SELECIONAR_TODOS_CLICK }
}

const MODAL_VISIBLE_TOGGLE = 'MODAL_VISIBLE_TOGGLE'
export function onModalVisibilityToggle(isVisible, selectedEntrega) {
  return { action: MODAL_VISIBLE_TOGGLE, payload: { isVisible, selectedEntrega } }
}

const CONSIDERAR_ENTREGAS_EM_SEPARACAO_TOGGLE = 'CONSIDERAR_ENTREGAS_EM_SEPARACAO_TOGGLE'
export function onConsiderarEntregasToggle() {
  return { action: CONSIDERAR_ENTREGAS_EM_SEPARACAO_TOGGLE }
}

const LOADING_TOGGLE = 'LOADING_TOGGLE'
export function onLoadingToggle(isVisible) {
  return { action: LOADING_TOGGLE, payload: isVisible }
}

const RESET_ENTREGAS = 'RESET_ENTREGAS'
export function onOnResetEntregas() {
  return { action: RESET_ENTREGAS }
}

// REDUCER
export const reducer = (state, { action, payload }) => {
  switch (action) {
    case GET_ENTREGAS:
      return {
        ...state,
        entregas: payload,
        originalEntregas: payload,
        isLoading: false,
      }
    case SELECTED_STATUS_CHANGE:
      return { ...state, selectedStatus: payload }
    case SELECTED_EMPRESAS_CHANGE:
      return { ...state, selectedEmpresas: payload }
    case MODELO_INTEGRACAO_CHANGE:
      return { ...state, selectedModeloIntegracao: payload }
    case SELECIONAR_TODOS_CLICK:
      return {
        ...state,
        selecionarTodos: !state.selecionarTodos,
        entregas: state.entregas.map(e => ({ ...e, selected: !state.selecionarTodos })),
      }
    case SELECIONAR_ENTREGA_CLICK:
      const index = state.entregas.findIndex(e => e.delivery_id === payload.delivery_id)
      if (index !== -1) {
        state.entregas[index].selected = !state.entregas[index].selected
        return { ...state, entregas: [...state.entregas] }
      } else {
        return { ...state }
      }
    case MODAL_VISIBLE_TOGGLE:
      return {
        ...state,
        modalIsVisible: payload.isVisible,
        selectedEntrega: payload.selectedEntrega,
      }
    case CONSIDERAR_ENTREGAS_EM_SEPARACAO_TOGGLE:
      return { ...state, considerarEntregasEmSeparacao: !state.considerarEntregasEmSeparacao }
    case LOADING_TOGGLE:
      return { ...state, isLoading: payload }
    case RESET_ENTREGAS:
      return {
        ...state,
        entregas: [],
        listaEmpresas: getEmpresas().map(e => ({ value: e.id, label: e.name })),
      }
    default:
      return { ...state }
  }
}

//Helper
